import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  AssociateSubClientAtClientModel,
  CreateSubClientModel,
  DeleteSubClientModel,
  SearchSubClientModel,
} from '../../../models/customer.model'
import { SearchEmployeeModel } from '../../../models/employee.model'

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Cliente'

  constructor(private httpClient: HttpClient) {}

  public deleteClient(idClient: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/${idClient}`,
      {},
    )
  }

  public listPagedEmployeeAssociateByClientId(
    page: number,
    rows: number = 15,
    idClient: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/associados/cliente/${idClient}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedEmployeeAssociateByClientId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idClient: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/associados/cliente/${idClient}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedEmployeeNotAssociateByClientId(
    page: number,
    rows: number = 15,
    idClient: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/nao-associados/cliente/${idClient}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedEmployeeNotAssociateByClientId(
    page: number,
    rows: number = 15,
    model: SearchEmployeeModel,
    idClient: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated/nao-associados/cliente/${idClient}?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public createClientAlsoSubclient(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}Cliente/client-to-subclient`,
      model,
    )
  }

  public createSubclientAlsoClient(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}SubCliente/subclient-to-client`,
      model,
    )
  }
}
